import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { ErrorBoundary } from '@/components/dev/ErrorBoundary'
import { Capacitor } from '@capacitor/core'
import { HashRouter, BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { StatusBar, Style } from '@capacitor/status-bar'
import { queryClient } from '@/lib/query/client'
import './index.css'

// Global crash logging to surface blank-screen causes
window.addEventListener('error', (e) => {
  // eslint-disable-next-line no-console
  console.error('[GlobalError]', (e as any).error || e.message, (e as any).filename, (e as any).lineno, (e as any).colno, e);
});
window.addEventListener('unhandledrejection', (e) => {
  // eslint-disable-next-line no-console
  console.error('[UnhandledRejection]', (e as any).reason || e);
});

// Ensure status bar does not overlay webview; prefer dark style
if (Capacitor.isNativePlatform()) {
  StatusBar.setOverlaysWebView({ overlay: false }).catch(()=>{});
  StatusBar.setStyle({ style: Style.Dark }).catch(()=>{});
}

// Comprehensive zoom prevention for iOS hybrid apps
if (Capacitor.isNativePlatform()) {
  // Prevent pinch-to-zoom gestures
  document.addEventListener('touchstart', (e) => {
    if (e.touches.length > 1) {
      e.preventDefault();
    }
  }, { passive: false });

  // Prevent double-tap zoom
  let lastTouchEnd = 0;
  document.addEventListener('touchend', (e) => {
    const now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });

  // Prevent zoom via wheel events
  document.addEventListener('wheel', (e) => {
    if (e.ctrlKey) {
      e.preventDefault();
    }
  }, { passive: false });

  // Prevent zoom via keyboard shortcuts
  document.addEventListener('keydown', (e) => {
    if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '0')) {
      e.preventDefault();
    }
  });
}
const Router: any = Capacitor.isNativePlatform() ? HashRouter : BrowserRouter;

createRoot(document.getElementById("root")!).render(
  <Router>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <App />
        {/* React Query DevTools - only in development */}
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </ErrorBoundary>
    </QueryClientProvider>
  </Router>
);
